import React from 'react';
// Types
import { pageMessages } from 'app/store/page/page.messages';
// Models
import { IPage } from '@root/models/Page';
import IInsuranceCase from 'app/models/Case';
// Store
import { useDispatch, useSelector } from 'react-redux';
// Actions
import PageActions from 'app/store/page/page.actions';
// Selectors
import { selectTrialMode } from 'app/store/AppUI/AppUI.selectors';
import { selectInsuranceCase } from 'app/store/Cases/Cases.selectors';
import { selectPageStaples, selectIsLoading } from 'app/store/page/page.selectors';
// Components
import ColorPalette from 'app/components/ColorPalette';

type Props = {
  page: IPage;
};

const CardPageColors:React.FC<Props> = ({
  // Props
  page
}) => {
  // Dispatch
  const dispatch = useDispatch();
  // State
  const trialMode = useSelector(selectTrialMode);
  const insuranceCase = useSelector(selectInsuranceCase) as IInsuranceCase;
  const staplePages:Array<IPage> | null = useSelector(selectPageStaples)
  const loading = useSelector(selectIsLoading);

  const handleColorClick = (nextColor:string) => {
    if ( loading ) return;

    const prevColors = page.colors || [];
    const colors = prevColors.includes(nextColor) ? prevColors.filter((c:any) => c !== nextColor) : [...prevColors, nextColor];
    const message = colors.length > 0 ? pageMessages.updatePageColor : pageMessages.removePageColor;
    if ( staplePages && page.staple && page.staple.order === 1 ){
      const pagesToUpdate = staplePages.map((page:IPage) => ({
        caseId: insuranceCase.id,
        documentId: page.documentId,
        pageNum: page.pageNum,
        version: page.version,
        colors
      }));
      dispatch(PageActions.patchPages(pagesToUpdate, message));
    } else {
      dispatch(PageActions.patchPage(page.documentId, page.pageNum, {
        version: page.version,
        colors
      }, message));
    }
  }

  return (
    <ColorPalette sx={{ mb: 4 }} activeColors={page.colors || []} showNoColorValue={false}>
      {(color) => (
        <ColorPalette.Item
          key={color}
          color={color}
          onClick={trialMode ? undefined : handleColorClick}
        />
      )}
    </ColorPalette>
  )
}

export default CardPageColors;
